/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_TagsInputs */

const en_metadata_merge_tags = /** @type {(inputs: Metadata_Merge_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const fr_metadata_merge_tags = /** @type {(inputs: Metadata_Merge_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étiquettes`)
};

const de_metadata_merge_tags = /** @type {(inputs: Metadata_Merge_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const it_metadata_merge_tags = /** @type {(inputs: Metadata_Merge_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etichette`)
};

const ru_metadata_merge_tags = /** @type {(inputs: Metadata_Merge_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Теги`)
};

const es_metadata_merge_tags = /** @type {(inputs: Metadata_Merge_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

const zh_cn2_metadata_merge_tags = /** @type {(inputs: Metadata_Merge_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签`)
};

const ja_metadata_merge_tags = /** @type {(inputs: Metadata_Merge_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグ`)
};

const hi_metadata_merge_tags = /** @type {(inputs: Metadata_Merge_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग`)
};

const pt_pt2_metadata_merge_tags = /** @type {(inputs: Metadata_Merge_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

/**
* | output |
* | --- |
* | "Tags" |
*
* @param {Metadata_Merge_TagsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_tags = /** @type {((inputs?: Metadata_Merge_TagsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_TagsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_tags(inputs)
	if (locale === "de") return de_metadata_merge_tags(inputs)
	if (locale === "it") return it_metadata_merge_tags(inputs)
	if (locale === "ru") return ru_metadata_merge_tags(inputs)
	if (locale === "es") return es_metadata_merge_tags(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_tags(inputs)
	if (locale === "ja") return ja_metadata_merge_tags(inputs)
	if (locale === "hi") return hi_metadata_merge_tags(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_tags(inputs)
	return en_metadata_merge_tags(inputs)
});